import React, { useContext, useEffect, useRef, useState } from "react";
import SupplierFilter from "../../components/SupplierFilter/SupplierFilter";
import QualityCertificateRequestsGrid from "./QualityCertificateRequestsGrid";
import { LoginContext } from "../../contexts/LoginContext";
import ViewPortGridWrapper from "../../containers/ViewPortGridWrapper";
import { Button, makeStyles, TextField } from "@material-ui/core";
import { commonFilter } from "../../constants/StyleConstants";
import useQualityCertificateRequestsPresenter from "./QualityCertificateRequestsPresenter";
import DefaultUnrederedGridMessage from "../../containers/DefaultUnrenderedGridMessage";
import MomentUtils from "@date-io/moment";
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import {
  strToDate,
  DATE_FORMAT,
  todayLastYearDate,
} from "../../utils/DateUtils";

const useStyles = makeStyles((theme) => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const { isSupplier, userInfo } = useContext(LoginContext);
  const {
    //oc,
    //setOc,
    selectedSupplier,
    setSelectedSupplier,

    purchaseOrderCode,
    setPurchaseOrderCode,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    validateAndSearch,
    cleanFilters,
  } = filtersProps;

  //const isScrapper = userInfo.role.includes("CHATARRERO")

  return (
    <div className={classes.filters}>
      {!isSupplier && (
        <SupplierFilter
          value={selectedSupplier}
          setValue={setSelectedSupplier}
        />
      )}

      <TextField
        margin="dense"
        id="purchaseOrder"
        style={{ width: 200 }}
        label="Nro. de pedido de compra"
        onChange={(e) => setPurchaseOrderCode(e.target.value)}
        value={purchaseOrderCode}
      />

      <CustomDatePicker2 value={dateFrom} maxDate={dateTo} label="Fecha desde" setValue={setDateFrom} />
      <CustomDatePicker2 value={dateTo} minDate={dateFrom} label="Fecha hasta" setValue={setDateTo} />

      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};

const CustomDatePicker2 = ({
  value,
  setValue,
  minDate,
  maxDate,
  label,
  disablePast,
  readOnly,
  disabled,
  style,
  disableMinDate,
  ...restProps
}) => {
  const handleBlur = e => {
    const dateValue = e.target.value;
    setValue(dateValue.isBlank() ? null : strToDate(dateValue));
  };

  return (
    <MuiPickersUtilsProvider utils={MomentUtils}>
      <KeyboardDatePicker
        style={{ width: 140, ...style }}
        disableToolbar
        disablePast={disablePast}
        disabled={disabled}
        autoOk
        variant="inline"
        format={DATE_FORMAT}
        margin="dense"
        invalidDateMessage="Fecha incorrecta"
        id={`date-picker-inline-${label}`}
        label={label || 'Fecha'}
        minDate={readOnly || minDate || disableMinDate ? minDate : undefined}
        maxDate={maxDate || undefined}
        value={value}
        onChange={() => undefined}
        onAccept={setValue}
        onBlur={!readOnly ? handleBlur : undefined}
        inputProps={{ readOnly: !!readOnly }}
        KeyboardButtonProps={{
          disabled: !!readOnly || !!disabled,
          'aria-label': 'change date',
        }}
        {...restProps}
      />
    </MuiPickersUtilsProvider>
  );
};


const QualityCertificateRequests = () => {
  const tableRef = useRef();
  const { isSupplier } = useContext(LoginContext);
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } =
    useQualityCertificateRequestsPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={isSupplier || !firstLoad}>
        <QualityCertificateRequestsGrid
          data={rows}
          loading={loading}
          tableRef={tableRef}
          {...gridFunctions}
        />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default QualityCertificateRequests;
